import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";
import { PaymentMethodEnum } from "../../data/enums";

export namespace AgentSettlementValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const CreateSettlement = defineValidation(
        v.object({
            associateUserId: baseVals.string(),
            method: v.picklist(PaymentMethodEnum.valuesCreate),
            account: baseVals.string(),
            settlementDate: baseVals.isoDate("Tanggal Penyetoran Dana"),
            settlementAmount: v.pipe(v.number(), v.minValue(1, "Pembayaran minimal Rp. 1")),
        }),
    );
}
